var React = require('react');

function Orders (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"m12.986 3.695-1.26 5.04c-.1.4-.457.679-.87.679H3.09a.896.896 0 0 1-.89-.793L1.29 1.345H.672A.672.672 0 1 1 .672 0h1.205c.336 0 .62.248.666.581l.35 2.557h9.659c.29 0 .505.274.434.557ZM2.69 11.655c0 .741.603 1.345 1.344 1.345.742 0 1.345-.604 1.345-1.345 0-.742-.603-1.345-1.345-1.345-.741 0-1.345.603-1.345 1.345ZM10.758 11.655c0-.742-.603-1.345-1.344-1.345-.742 0-1.345.603-1.345 1.345 0 .741.603 1.345 1.345 1.345.741 0 1.344-.604 1.344-1.345Z"})));
}

Orders.defaultProps = {"fill":"none","viewBox":"0 0 13 13"};

module.exports = Orders;

Orders.default = Orders;
